<div class="container-shadow px-3 pb-4 mx-auto pt-4" style="max-width: 45rem">
  <h2 class="text-center">New Contact</h2>
  <app-contact-form></app-contact-form>
</div>